export default {
      id: "big-plus-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "sprite.svg#big-plus",
      toString: function () {
        return this.url;
      }
    }